import React, { useCallback, useState } from "react";

import { IonLoading, IonAlert } from "@ionic/react";

import { useHistory } from "react-router-dom";

import ApolloClient from "../../services/apollo";
import { PassageForm } from "../../interfaces/passage";
import { gql } from "apollo-boost";

const mutation = gql`
  mutation createTicket(
    $date: Date!
    $hour: String!
    $minutes: String!
    $arrival_location_id: Int!
    $departure_location_id: Int!
    $observation: String
    $price: Float
    $car_id: String!
  ) {
    createTicket(
      date: $date
      hour: $hour
      minutes: $minutes
      arrival_location_id: $arrival_location_id
      departure_location_id: $departure_location_id
      observation: $observation
      price: $price
      car_id: $car_id
    ) {
      id
      status
    }
  }
`;

interface Alert {
  show: boolean;
  type: string;
  message?: string;
}

interface TicketComponentProps {
  loading: boolean;
  alert: Alert;
  setAlert(): void;
  setLoading(): void;
  onSuccess?(): void;
}

type statusOptions = {
  [key: string]: string;
};

const typesError: statusOptions = {
  VACANCY_FULL: "Ops... a van selecionada já esta lotada",
  CAR_NOT_FOUND: "Infelizmente o carro selecionado esta com algum problema",
  unknown: "Ops... não foi possível terminar a solicitação de passagem",
  success: "Em poucos minutos você vai receber a confirmação",
};

export const TicketComponent: React.FC<TicketComponentProps> = ({
  loading,
  alert,
  setLoading,
  setAlert,
  onSuccess,
}) => {
  const { push } = useHistory();
  const onDidDismiss = useCallback(() => {
    setAlert();
    if (alert.type === "success") {
      if (onSuccess) {
        onSuccess();
      } else {
        push("/page/passages");
      }
    }
  }, [alert.type]);

  if (loading) {
    return (
      <IonLoading
        isOpen={loading}
        onDidDismiss={() => setLoading()}
        message={"Solicitando passagem"}
      />
    );
  }

  if (alert.show && alert.type) {
    return (
      <IonAlert
        isOpen={alert.show}
        onDidDismiss={onDidDismiss}
        header={alert.type === "success" ? "Pedido concluído!" : "Alerta"}
        // subHeader={"Subtitle"}
        message={alert.message || typesError[alert.type]}
        buttons={["OK"]}
      />
    );
  }
  return null;
};

const useCreateTicket = (form: PassageForm) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [alert, setAlert] = useState<any>({
    show: true,
    type: null,
    message: undefined,
  });

  // const [ticket, setTicket] = useState<any>({});

  const send = useCallback(() => {
    setLoading(true);
    ApolloClient.mutate({
      mutation,
      variables: form,
    })
      .then(({ data }) => {
        setLoading(false);
        return setAlert((prevError: Alert) => ({
          ...prevError,
          show: true,
          type: "success",
        }));
      })
      .catch((err) => {
        const { graphQLErrors } = err;
        let type = "unknown";
        let message: any = undefined;
        if (graphQLErrors.length) {
          const { name, message: alertMessage } = graphQLErrors[0];
          type = name;
          message = alertMessage;
        }
        setLoading(false);
        return setAlert((prevError: Alert) => ({
          ...prevError,
          show: true,
          type,
          message,
        }));
      });
  }, [form]);

  return {
    loading,
    alert,
    send,
    setAlert: () =>
      setAlert((prevError: any) => ({
        ...prevError,
        show: false,
        type: null,
        message: undefined,
      })),
    setLoading: () => setLoading(false),
  };
};

export default useCreateTicket;
